import { render } from "./pos-states.vue?vue&type=template&id=500ef2af"
import script from "./pos-states.vue?vue&type=script&lang=js"
export * from "./pos-states.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__